const videoOrigin = 'https://pub-dfd09a1f367a4139805489ff686a8b0d.r2.dev';

export const getVideoSource = source => {
  if (!source) return source;
  try {
    const url = new URL(source);
    if (url.origin === videoOrigin) return `/api/video?src=${encodeURIComponent(url.href)}`;
  } catch {}
  return source;
};
